import { useAtomValue } from "jotai";
import { useCallback, useEffect, useState } from "react";
import { isSeparateDisplayControllerAtom, mainMapAtom, subMapAtom } from "../atoms";
import { MapLibreEvent } from "maplibre-gl";
import { MAIN_MAP_ID } from "../constants/components/map";
import { mapType } from "../types";


export const useSeparateDisplay = (map: maplibregl.Map | null, mapType: mapType) => {

  const isSeparateDisplay = useAtomValue(isSeparateDisplayControllerAtom);
  const mainMap = useAtomValue(mainMapAtom);
  const subMap = useAtomValue(subMapAtom);
  const [targetMap, setTargetMap] = useState<maplibregl.Map | null>(null);

  // --------------------------------------------------

  const syncMaps = useCallback((e: MapLibreEvent<MouseEvent | TouchEvent | WheelEvent | undefined>) => {
    if(!('type' in e) || !targetMap || !map) { return; }

    targetMap.off('move', syncMaps);

    targetMap.setCenter(map.getCenter())
    targetMap.setZoom(map.getZoom())
    targetMap.setPitch(map.getPitch())
    targetMap.setBearing(map.getBearing())
  }, [targetMap, map]);

  // --------------------------------------------------


  useEffect(() => {
    // ターゲットのマップを取得
    setTargetMap(mapType === MAIN_MAP_ID ? subMap : mainMap);
  }, [mapType, mainMap, subMap]);
  

  useEffect(() => {
    if (!map) { return; }
    
    if(isSeparateDisplay) {
      map.on('move', syncMaps);
    }
    return () => {
      map.off('move', syncMaps);
    }
    
  }, [isSeparateDisplay, map]);
  
};
